/*
 * vrtOTClaim.us
 * vue router: Claim
 *
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtOTClaim: RouteRecordRaw = {
  path: '/eservices/OTclaim',
  name: 'vrtOTClaim',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'view',
      name: 'vrtOTClaimView',
      component: () => import('./vpgOTClaimList.vue'),
    },
    {
      path: 'update',
      name: 'vrtOTClaimUpdate',
      component: () => import('./vpgOTClaimUpdate.vue'),
    },
    {
      path: 'create',
      name: 'vrtOTClaimCreate',
      component: () => import('./vpgOTClaimCreate.vue'),
    },
    {
      path: 'details',
      name: 'vrtOTClaimDetails',
      component: () => import('./vpgOTClaimDetails.vue'),
    },
    {
      path: 'report',
      name: 'vrtOTClaimReport',
      component: () => import('./vpgOTClaimReport.vue'),
    },
    {
      path: 'release',
      name: 'vrtOTClaimRelease',
      component: () => import('./vpgOTClaimRelease.vue'),
    },
  ],
};
//
export default vrtOTClaim;
//#end#
